<h4 class="f-w-700 f-s-24 m-t-24 m-b-8">{{ "recovery_password.recovery_password" | translate}}</h4>
<span class="f-s-14 d-block f-s-14 m-t-8">
  {{ "recovery_password.insert_new_password_reset" | translate}}
</span>
<mat-card class="shadow-none bg-light-secondary m-t-4">
  <div class="p-0 p-l-14 p-r-14">
    <div class="row justify-content-between">
      <div class="col-sm-12">
        <mat-card-subtitle class="mat-mdc-card-subtitle mat-body-1 text-dark m-t-12 lh-24 m-b-20">
          <h3> {{ "recovery_password.password_rules" | translate }}</h3>
          <ul>
            <li>{{ "recovery_password.rules_1" | translate }}</li>
            <li>{{ "recovery_password.rules_2" | translate }}</li>
            <li>{{ "recovery_password.rules_3" | translate }}</li>
            <li>{{ "recovery_password.rules_4" | translate }}</li>
          </ul>
        </mat-card-subtitle>
      </div>
    </div>
  </div>
</mat-card>
<form class="m-t-30" [formGroup]="recovery_password_reset" (ngSubmit)="onSubmit()" #passwordResetDir="ngForm">
  <mat-label class="f-s-14 f-w-600 m-b-6 d-block">
    {{ "recovery_password.new_password" | translate}}
  </mat-label>
  <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
    <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="new_password1"/>
    <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideNewPassword = !hideNewPassword"
            [attr.aria-label]="(hideNewPassword ? 'login.show_password' : 'login.hide_password') | translate"
            [attr.aria-pressed]="!hideNewPassword">
      <i-tabler [name]="hideNewPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
    </button>
  </mat-form-field>
  <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="password1FormControl?.hasError('required') && (password1FormControl?.touched || passwordResetDir.submitted)">
    {{ 'login.password_required' | translate }}
  </mat-error>
  <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="password1FormControl?.hasError('minlength') && (password1FormControl?.touched || passwordResetDir.submitted)">
    {{ 'recovery_password.password_min_length' | translate: { minLength: passwordMinLength } }}
  </mat-error>
  <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="password1FormControl?.hasError('passwordStrength') && (password1FormControl?.touched || passwordResetDir.submitted)">
    {{ 'recovery_password.password_strength_error' | translate }}
  </mat-error>

  <mat-label class="f-s-14 f-w-600 m-t-8 d-block">
    {{ "recovery_password.confirm_password" | translate}}
  </mat-label>
  <mat-form-field appearance="outline" class="w-100 hide-hint" color="primary">
    <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="new_password2"/>
    <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideConfirmPassword = !hideConfirmPassword"
            [attr.aria-label]="(hideConfirmPassword ? 'login.show_password' : 'login.hide_password') | translate"
            [attr.aria-pressed]="!hideConfirmPassword">
      <i-tabler [name]="hideConfirmPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
    </button>
  </mat-form-field>
  <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="password2FormControl?.hasError('required') && (password2FormControl?.touched || passwordResetDir.submitted)">
    {{ 'login.password_required' | translate }}
  </mat-error>
  <mat-error class="mat-mdc-form-field-subscript-wrapper p-l-16" *ngIf="recovery_password_reset.hasError('passwordMismatch') && (recovery_password_reset.touched || passwordResetDir.submitted)">
    {{ 'recovery_password.passwords_dont_match' | translate }}
  </mat-error>

  <button mat-flat-button color="primary" class="w-100 m-t-8" [disabled]="!recovery_password_reset.valid">
    {{ 'recovery_password.reset_password' | translate }}
  </button>
  <a href="javascript:void(0)" (click)="goBack()" mat-stroked-button color="primary" class="w-100 m-t-8">
    {{ 'recovery_password.back_recovery_password' | translate }}
  </a>
</form>
